import { createSlice, PayloadAction } from '@reduxjs/toolkit';

/**
 * 初期型
 */
export interface JobTagsState {
  targetMemberTags: string[];
}

/**
 * Slice型
 */
export interface JobTagsSliceState {
  jobTags: ReturnType<typeof jobTagsReducer>;
}

/**
 * 初期状態
 */
export const jobTagsInitialState: JobTagsState = {
  targetMemberTags: [],
};

/**
 * slice
 */
const jobTagsSlice = createSlice({
  name: 'jobTags',
  initialState: jobTagsInitialState,
  reducers: {
    setTargetMemberTags: (state, action: PayloadAction<string[]>) => {
      state.targetMemberTags = action.payload;
    },
  },
});

export const { setTargetMemberTags } = jobTagsSlice.actions;

export const jobTagsReducer = jobTagsSlice.reducer;

type State = JobTagsSliceState;

/**
 * Selector targetMemberTagsSelector
 * @param state
 * @returns targetMemberTags
 */
export const targetMemberTagsSelector = <S extends State>(state: S) =>
  state.jobTags.targetMemberTags;
